<template><div></div></template>

<script setup lang="ts">
import "littlefoot/dist/littlefoot.css";

import { littlefoot } from "littlefoot";

if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  littlefoot();
}
</script>
